import React, { CSSProperties, useEffect, useState } from "react";
import { Image, List, InfiniteScroll, PullToRefresh, SearchBar, Card } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import { queryAncientInfo } from "./service";

const TreeListScreen: React.FC = React.memo((props) => {
  const navigation = useNavigate();
  const [ancient, setAncient] = useState<APIGarden.AncientItem[]>([]);

  const [hasMore, setHasMore] = useState(true);
  const [pageSize, setPageSize] = useState<number>(20);
  useEffect(() => { }, []);
  //树木无限滚动
  const loadMore = async () => {
    setPageSize(pageSize + 20);
    const res = await queryAncientInfo(pageSize, 1);
    if (res.success) {
      const list = res.data.sort((item1: any, item2: any) => {
        if (item1.roadOrder === item2.roadOrder) {
          const sort1 = item1.number
          const sort2 = item2.number
          return sort1 - sort2
        }
        return item1.roadOrder - item2.roadOrder
      })
      setAncient(list);
      if (res.total < pageSize) {
        setHasMore(false);
      }
    } else {
      setHasMore(false);
    }
  };
  // 搜索
  const handleSearch = (values: string) => {
    queryAncientInfo(10000, 1, values).then((data) => {
      if (data.success) {
        setAncient(data.data);
        setHasMore(false);
      }
    })
  }
  //重置搜索内容
  const refresh = async () => {
    const res = await queryAncientInfo(20, 1);
    if (res.success) {
      setAncient(res.data);
      setHasMore(true);
    }
  }
  return (
    <div style={container}>
      {/* 下拉刷新 */}
      <PullToRefresh
        onRefresh={async () => {
          const res = await queryAncientInfo(20, 1);
          if (res.success) {
            setAncient(res.data);
            if (res.total < 20) {
              setHasMore(false);
            }
          } else {
            setHasMore(false);
          }
        }}
      >
        <Card
          style={{ padding: "0" }}
          bodyStyle={{ backgroundColor: "#f5f5f5" }}
        >
          <SearchBar
            onSearch={(val) => handleSearch(val)}
            onClear={() => refresh()}
            placeholder='请输入路段，牌号或树木名称'
            style={{
              'margin': 'auto',
              'width': '95%',
              '--background': '#ffffff',
              '--height': '40px',
              '--padding-left': '12px',
            }}
          />
        </Card>
        <List>
          {ancient.map((ancient) => (
            <List.Item
              key={ancient.id}
              prefix={
                <Image
                  src={ancient.picPathFull ? ancient.picPathFull : ""}
                  width={60}
                  height={60}
                  style={{ borderRadius: 4 }}
                />
              }
              description={
                <div>
                  <div>牌号：{ancient.number}</div>
                  <div>地址：{ancient.placeName}</div>
                </div>
              }
              onClick={() => navigation("/tree/create", { state: ancient.id })}
            >
              {ancient.treeSpecies}
            </List.Item>
          ))}
        </List>
        {/* 无限滚动分页 */}
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore} threshold={10} />
      </PullToRefresh>
    </div>
  );
});

const container: CSSProperties = {};

export default TreeListScreen;
